/**
 * Lib
 * Tools and such
 */

/**
 * Find Closest parent of element matching selector
 * @param {elementNode} el
 * @param {string} selector
 */

export function closest(el, selector) {
  const matchesSelector =
    el.matches
    || el.webkitMatchesSelector
    || el.mozMatchesSelector
    || el.msMatchesSelector;

  let desiredEl = el;
  while (desiredEl) {
    if (matchesSelector.call(desiredEl, selector)) {
      break;
    }
    desiredEl = desiredEl.parentElement;
  }
  return desiredEl || false;
}


/**
 * Wrap element with a div with a class
 * @param {elementNode} node
 * @param {string} className
 */

export function wrap(node, className) {
  const wrapperClass = className || null;
  const container = document.createElement('div');
  if (className) {
    container.className = wrapperClass;
  }
  container.innerHTML = node.outerHTML;
  node.parentElement.insertBefore(container, node);
  node.parentElement.removeChild(node);
}

// Vimeo API

export const Vimeo = {

  /**
  * Play a Vimeo video
  * @param {elementNode} el
  */
  play: (el) => {
    if (!el) return false;
    return el.contentWindow.postMessage({ method: 'play' }, el.src);
  },

  /**
  * Pause a Vimeo video
  * @param {elementNode} el
  */
  pause: (el) => {
    if (!el) return false;
    return el.contentWindow.postMessage({ method: 'pause' }, el.src);
  },
};

// Vue filters

export function mYYYY(val) {
  const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const date = new Date(val);
  return `${monthNames[date.getMonth()]} ${date.getFullYear()}`;
}

export function commas(val) {
  if (val > 0) {
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  return false;
}

export function inMegabytes(val) {
  return `${(val / (1024 ** 2)).toFixed(1)} MB`;
}

export function json(val) {
  return JSON.stringify(val);
}

export function price(val) {
  if (val > 0) {
    const inCents = val / 100;
    const withCommas = inCents.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return `$${withCommas.replace(/\.00/g, '')}`;
  }
  return false;
}



// WEBPACK FOOTER //
// ./lib.js